<template>
  <ClientOnly>
    <DmModal
      v-model="modals.phone"
      :title="garagePremium ? 'Zadzwoń i umów wizytę' : 'Pokaż dane kontaktowe'"
      class="garage-phone-modal"
    >
      <template v-if="garagePremium">
        <div class="garage-phone-modal">
          <div class="garage-phone-modal__phone">
            <NuxtImg
              width="20px"
              height="20px"
              src="/_nuxt/telephone.svg"
              alt="Numer telefonu"
            />
            <a :href="`tel:+48${phoneVirtual}`">{{ formattedPhoneToShow }}</a>
          </div>

          <div
            class="garage-phone-modal__conditions-wrapper"
            v-if="!!garageVirtualPhones[0]?.forwardToCallCenter"
          >

            <p class="garage-phone-modal__conditions">
              Zostaniesz połączony z Doradcą Serwisowym, który w trakcie rozmowy zapyta Cię o dane dotyczące Twojego
              auta - zapytania te mogą się różnić w zależności od usługi, na którą chcesz się umówić. Podstawowe dane, o
              które pytamy to: marka i model auta, rok produkcji, pojemność i moc silnika, rodzaj paliwa, rodzaj skrzyni
              biegów - w razie potrzeby.<span v-show="!showMore">.. </span>
              <span
                v-show="!showMore"
                class="garage-phone-modal__conditions-show-more"
                @click="showMore = true"
              >Pokaż więcej</span>
            </p>

            <p
              v-show="showMore"
              class="garage-phone-modal__conditions"
            >
              W celu umówienia wizyty w warsztacie Doradca Serwisowy portalu dobrymechanik.pl poprosi Cię również o dane
              kontaktowe takie jak imię i nazwisko i nr telefonu.
            </p>
            <p
              v-show="showMore"
              class="garage-phone-modal__conditions"
            >
              Twoje dane automatycznie zapisują się w bazie danych portalu DobryMechanik.pl. Przetwarzamy te dane
              osobowe, aby móc oferować Ci nasze usługi. Szczegółowe zasady przetwarzania Twoich danych, w tym Twojego
              numeru telefonu opisaliśmy w <a
                target="_blank"
                href="/pomoc/polityka_prywatnosci/"
              ><u>Polityce Prywatności</u>.</a>
            </p>
          </div>
          <div
            v-else
            class="garage-phone-modal__conditions-wrapper"
          >
            <p class="garage-phone-modal__conditions">Dzwoniąc pod wskazany numer warsztatu, Twój numer telefonu
              automatycznie zapisuje się w bazie danych
              portalu
              DobryMechanik.pl. Szczegółowe zasady przetwarzania Twojego numeru telefonu opisaliśmy w
              <a
                target="_blank"
                href="/pomoc/polityka_prywatnosci/"
              >Polityce Prywatności.</a><span v-show="!showMore">.. </span>
              <span
                v-show="!showMore"
                class="garage-phone-modal__conditions-show-more"
                @click="showMore = true"
              >Pokaż więcej</span>
            </p>
            <p
              class="garage-phone-modal__conditions"
              v-show="showMore"
            >
              Twój numer telefonu będzie również udostępniony warsztatowi, z którym się kontaktujesz. Warsztat będzie
              przetwarzać Twoje dane niezależnie, zgodnie ze swoimi zasadami.
            </p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="garage-phone-modal__no-premium">
          <div class="garage-phone-modal__no-premium-info">
            <NuxtImg
              width="24px"
              height="24px"
              alt="Twoja prośba została wysłana"
              src="/_nuxt/warning.svg"
            />
            Ten warsztat samochodowy nie udostępnił danych kontaktowych.
            <span v-show="suggestedGarages?.length">Poniżej znajdziesz warsztaty w okolicy do których
              umówisz się online.</span>
          </div>

          <GarageAdsensePhone v-if="!garage?.premium && !suggestedGarages?.length" />

          <GarageSuggestedGarages
            title="Szukasz mechanika? Klienci polecają:"
            :itemsToShow="1.2"
            :garage="garage"
            :suggestedGarages="suggestedGarages"
          />
        </div>
      </template>
    </DmModal>
  </ClientOnly>
</template>

<script
  setup
  lang="ts"
>
import { DmModal, DmButton } from '@dobrymechanik/vue-ui-v2';
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead, GarageVirtualPhoneNumberJsonldVirtualPhoneRead, RankingJsonldSuggestedGarageReadRankingRead } from '~/api/docs/api';
import GarageAdsensePhone from './GarageAdsensePhone.vue';

interface IProps {
  modals: any;
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  phoneNumber?: string | number;
  garagePremium: boolean;
  suggestedGarages?: RankingJsonldSuggestedGarageReadRankingRead[];
  garageVirtualPhones: GarageVirtualPhoneNumberJsonldVirtualPhoneRead[];
}

// use
const route = useRoute();

// props
const props = defineProps<IProps>();

// data
const showMore: Ref<boolean> = ref(false);

// computed
const phoneVirtual = computed(() => {
  return !!props.garageVirtualPhones?.length ? props.garageVirtualPhones[0].phoneVirtual : props.garage?.phone;
});
const formattedPhoneToShow = computed(() => {
  return !!props.garageVirtualPhones?.length ? props.garageVirtualPhones[0].phoneFormatted : props.garage?.phone;
})

</script>

<style lang="scss">
@import url('assets/styles/components/garage-phone-modal.scss');
</style>